module.exports = __webpack_public_path__ + "5aef7d5c0ee88d1a6bbee59f1aab93ef.MP3";